import { string } from 'prop-types'
import { PureComponent } from 'react'
import { compose } from 'redux'

import { withI18n } from 'shared/utils/withI18n'
import Button from 'views/components/atoms/Button'
import Form from 'views/components/atoms/Form'
import Input from 'views/components/atoms/Input'
import withMountPoints from 'views/enhancers/withMountPoints'
import { i18nType, mountPointsType } from 'views/utils/propTypes'

import 'views/assets/stylesheets/atoms/_inputWithClear.scss'
import './OnPageSearchForm.scss'

class OnPageSearchForm extends PureComponent {
  static propTypes = {
    query: string,
    className: string,
    i18n: i18nType.isRequired,
    mountPoints: mountPointsType.isRequired,
  }

  static defaultProps = {
    query: '',
    className: '',
  }

  render() {
    const { i18n, mountPoints } = this.props
    const searchRoute = mountPoints.getSearch({
      query: null,
    })

    return (
      <Form
        className={`m-OnPageSearchForm ${this.props.className}`}
        name="on-page-search"
        method="GET"
        action={searchRoute}
        data-clientside-hook="chargeUrlSearchParams"
      >
        <Input
          className="m-OnPageSearchForm__input a-inputWithClear"
          type="search"
          name="query"
          defaultValue={this.props.query}
          placeholder={i18n._('general.label.placeholder.search')}
        />
        <Button
          className="m-OnPageSearchForm__button"
          type="submit"
          name="submit"
        >
          {i18n._('general.button.label.search')}
        </Button>
      </Form>
    )
  }
}

export default compose(withI18n(), withMountPoints)(OnPageSearchForm)
